import React, {useEffect, useState} from "react"

const Embeded = (props) => {
    // when the finalurl is present embed it
    const [embedLink, setEmbedLink] = useState(null)

    // view the incoming url
    useEffect( () => {
        // the url shoudl contain png and page number
        // remove page number
        let newUrl = props.url.replace(/\/pg_[\d]+/, '')

        // replace png with pdf
        let finalUrl = newUrl.replace(/.png/, '.pdf')

        console.log(finalUrl)

        // set as url
        setEmbedLink(<embed src={finalUrl} className="embededContent"></embed>)

    }, [props.url])

    return (
        <>
            <div className="embededContainer">
                {embedLink}
            </div>
        </>
    )
}

export default Embeded